// @ts-strict-ignore
import LocalizedLink from './Localization/LocalizedLink'
import { Box, OldHeading, Image, linkStyle, theme } from '@gassan-ui'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

const LinkSpan = styled.span`
  ${linkStyle};
  border-bottom: 1px solid currentColor;
  color: currentColor;
`

type Props = {
  mobileImage: string
  desktopImage: string
  title: string
  href: string
  contentPosition: 'top' | 'bottom'
  variant: 'light' | 'dark'
}

const ProductGridCTABlock: FC<Props> = ({
  title,
  href,
  mobileImage,
  desktopImage,
  contentPosition,
  variant,
}) => {
  const { t } = useTranslation('global')
  return (
    <LocalizedLink href={href} passHref>
      <a
        title={title}
        className={cn(
          'group relative col-[1_/_span_2] w-full overflow-hidden bg-oldLace pt-[68%]',
          'lg:col-auto lg:pt-[140%]',
        )}
      >
        <Box
          position="absolute"
          height={{
            _: 'calc(100% - 2rem)',
            small: 'calc(100% - 4rem)',
            large: 'calc(100% - 2rem)',
            xlarge: 'calc(100% - 4rem)',
          }}
          width={{
            _: 'calc(100% - 2rem)',
            small: 'calc(100% - 4rem)',
            large: 'calc(100% - 2rem)',
            xlarge: 'calc(100% - 4rem)',
          }}
          top={{
            _: '1rem',
            small: '2rem',
            large: '1rem',
            xlarge: '2rem',
          }}
          left={{
            _: '1rem',
            small: '2rem',
            large: '1rem',
            xlarge: '2rem',
          }}
        >
          <Box position="relative" height="100%" width="100%">
            <Image
              alt={title}
              sources={[mobileImage, mobileImage, desktopImage]}
              className={cn(
                'absolute z-0 h-full w-full opacity-100 transition-opacity duration-300',
                'group-hover:opacity-80',
              )}
            />
            <Box
              position="absolute"
              color={variant === 'dark' ? theme.colors.shades[800] : 'white'}
              left={{
                _: '1rem',
                small: '2.5rem',
                large: '1rem',
                xlarge: '2rem',
              }}
              bottom={
                contentPosition === 'bottom' && {
                  _: '1rem',
                  small: '2.5rem',
                  large: '2rem',
                }
              }
              top={
                contentPosition === 'top' && {
                  _: '1rem',
                  small: '2.5rem',
                  large: '2rem',
                }
              }
              width={{
                _: 'calc(100% - 2rem)',
                small: 'calc(100% - 5rem)',
                large: 'calc(100% - 2rem)',
                xlarge: 'calc(100% - 5rem)',
              }}
            >
              <OldHeading variant="h3" as="h3" color="currentColor" mb="0.5rem">
                {title}
              </OldHeading>
              <LinkSpan>{t('view')}</LinkSpan>
            </Box>
          </Box>
        </Box>
      </a>
    </LocalizedLink>
  )
}

export default ProductGridCTABlock
